import { render, staticRenderFns } from "./TransaksiReturnView.vue?vue&type=template&id=6f94147c"
import script from "./TransaksiReturnView.vue?vue&type=script&lang=js"
export * from "./TransaksiReturnView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports